import { ApparelSanityProductCategoryNames } from './apparel-sanity-product-category-names';
import { AccessoriesSanityProductCategoryNames } from './accessories-sanity-product-category-names';

export const ApparelAndAccessoriesSanityProductCategoryNames = [
  ...ApparelSanityProductCategoryNames,
  ...AccessoriesSanityProductCategoryNames,
];
